import { TabFragment } from '@graphql/generated';

type Props = {
  tabs: TabFragment[];
};

export const ProductTabs = ({ tabs = [] }: Props) => {
  if (tabs.length == 0) {
    return null;
  }
  return (
    <div className="product-detail">
      {tabs.map((tab, index) => (
        <div className="product-detail__item" key={index}>
          <h2 className="product-detail__title">{tab.title}</h2>
          <div
            className="product-detail__content"
            dangerouslySetInnerHTML={{ __html: tab.description }}
          />
        </div>
      ))}
    </div>
  );
};
